import { render, staticRenderFns } from "./ViewMessageParent.vue?vue&type=template&id=c312fa28&scoped=true"
import script from "./ViewMessageParent.vue?vue&type=script&lang=js"
export * from "./ViewMessageParent.vue?vue&type=script&lang=js"
import style0 from "./ViewMessageParent.vue?vue&type=style&index=0&id=c312fa28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c312fa28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c312fa28')) {
      api.createRecord('c312fa28', component.options)
    } else {
      api.reload('c312fa28', component.options)
    }
    module.hot.accept("./ViewMessageParent.vue?vue&type=template&id=c312fa28&scoped=true", function () {
      api.rerender('c312fa28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parentdiary/ViewMessageParent.vue"
export default component.exports